export const isTokenAvailableSelector = (state) => !!state.auth.token;
export const isLoadingSelector = (state) => state.auth.isLoading;
export const userIdSelector = (state) => state.auth.userId;
